import type { PresentationStatePayload } from '@mentimeter/realtime';
import type { SeriesForPresentation } from '@mentimeter/http-clients';
import type { InternalState } from './types';

export const getPresentationPayloadFromState = (
  state: InternalState,
  internalSeries: SeriesForPresentation,
): PresentationStatePayload => ({
  id: state.id,
  slidePublicKey: state.slidePublicKey,
  step: state.step,
  newStep: state.newStep,
  isInQuizLobby: state.isInQuizLobby,
  currentStep: state.currentStep,
  nextStep: state.nextStep,
  slideIndex: state.slideIndex,
  totalSlides: state.totalSlides,
  hasReachedEnd: state.hasReachedEnd,
  hasNextSlide: state.hasNextSlide,
  hasNextStep: state.hasNextStep,
  hasNewNextStep: state.hasNewNextStep,
  hasPreviousSlide: state.hasPreviousSlide,
  hasPreviousStep: state.hasPreviousStep,
  hasNewPreviousStep: state.hasNewPreviousStep,
  hasPrevious: state.hasPrevious,
  hasNewPrevious: state.hasNewPrevious,
  hasNext: state.hasNext,
  hasNewNext: state.hasNewNext,
  internalSeries,
  slideStates: state.slideStates,
  blankScreenVisible: state.blankScreenVisible,
  qrCodePlacement: state.qrCodePlacement,
});

export const getPresentationStateFromPayload = (
  state: PresentationStatePayload,
): InternalState => ({
  id: state.id,
  slidePublicKey: state.slidePublicKey,
  step: state.step,
  newStep: state.newStep,
  isInQuizLobby: state.isInQuizLobby,
  currentStep: state.currentStep,
  nextStep: state.nextStep,
  slideIndex: state.slideIndex,
  totalSlides: state.totalSlides,
  hasReachedEnd: state.hasReachedEnd,
  hasNextSlide: state.hasNextSlide,
  hasNextStep: state.hasNextStep,
  hasNewNextStep: state.hasNewNextStep,
  hasPreviousSlide: state.hasPreviousSlide,
  hasPreviousStep: state.hasPreviousStep,
  hasNewPreviousStep: state.hasNewPreviousStep,
  hasNext: state.hasNext,
  hasNewNext: state.hasNewNext,
  hasPrevious: state.hasPrevious,
  hasNewPrevious: state.hasNewPrevious,
  slideStates: state.slideStates,
  blankScreenVisible: state.blankScreenVisible,
  qrCodePlacement: state.qrCodePlacement,
});
